__turbopack_context__.v({
  "disclaimerSection": "Disclaimer-module__nxvYDW__disclaimerSection",
});
